import { combineReducers, configureStore, PayloadAction } from "@reduxjs/toolkit";
import CurrentUserSlice from "./slices/CurrentUserSlice";
import OnBoardingSlice from "./slices/OnBoardingSlice";
import UserSlice from "./slices/UserSlice";
import OfficeSlice from "./slices/OfficeSlice";
import FileSlice from "./slices/FileSlice";
import ServiceSlice from "./slices/ServiceSlice";
import ErrorSlice from "./slices/ErrorSlice";
import RequestSlice from "./slices/RequestSlice";
import OfficeRequestSlice from "./slices/OfficeRequestSlice";
import PatienSlice from "./slices/PatientSlice";
import FeeSlice from "./slices/FeeSlice";
import PaymentSlice from "./slices/PaymentSlice";
import NotificationSlice from "./slices/NotificationSlice";
import FinanceSlice from "./slices/FinanceSlice";
import SearchSlice from "./slices/SearchSlice";
import FormSlice from "./slices/FormSlice";
import annualPlanSlice from "./slices/annualPlanSlice";

import EmailTemplateSlice from "./slices/EmailTemplateSlice";
import passwordVisibilitySlice from "./slices/passwordVisibilitySlice";
import fileUploadSlice from "./slices/fileUploadSlice";
import selectedPlansReducer from "./slices/selectedPlanSlice";
import OfficeOnboardingSlice from "./slices/OfficeOnboardingSlice";

const rootReducer = combineReducers({
  user: UserSlice,
  office: OfficeSlice,
  currentUser: CurrentUserSlice,
  onBoarding: OnBoardingSlice,
  officeOnboarding: OfficeOnboardingSlice,
  file: FileSlice,
  service: ServiceSlice,
  error: ErrorSlice,
  request: RequestSlice,
  officeRequest: OfficeRequestSlice,
  patient: PatienSlice,
  fees: FeeSlice,
  payment: PaymentSlice,
  notifications: NotificationSlice,
  finance: FinanceSlice,
  searchResults: SearchSlice,
  form: FormSlice,
  annualPlan: annualPlanSlice,
  EmailTemplateSlice: EmailTemplateSlice,
  passwordVisibility: passwordVisibilitySlice,
  fileUpload: fileUploadSlice,
  selectedPlans: selectedPlansReducer,
});

export const resetState = () => ({
  type: "RESET_STATE",
});

const appReducer = (state: any, action: PayloadAction) => {
  let updatedState = state;
  if (action.type === "RESET_STATE") {
    updatedState = undefined;
  }
  return rootReducer(updatedState, action);
};

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: appReducer,
    preloadedState,
    middleware: getDefaultMiddleware => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
  });
};

export const store = setupStore();

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof appReducer>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
